export const debug = import.meta.env.DEV || import.meta.env.MODE === 'dev';

export const API_URLS = {
  redemption: import.meta.env.VITE_REDEMPTION_API_URL,
  token: import.meta.env.VITE_TOKEN_API_URL,
  forms: import.meta.env.VITE_FORMS_API_URL,
};

export const DOMAIN_URL = import.meta.env.VITE_TIKKIE_DOMAIN_URL;
